import { useEffect, useRef, useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { useLazyGetAccountsPayableQuery } from '../../services/accountsPayableApi';
import { RequestTimeoutState, useRequestTimeout } from '../useRequestTimeout';
export function useGetAccountsPayable() {
    const { t } = useTranslation();
    const [trigger] = useLazyGetAccountsPayableQuery();
    const { state: requestState, startTracking, stopTracking, reset } = useRequestTimeout();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const [accountsPayable, setAccountsPayable] = useState();
    const requestIdRef = useRef(0);
    const timedOutRef = useRef(false);
    useEffect(() => {
        if (requestState === RequestTimeoutState.Timeout) {
            timedOutRef.current = true;
            setLoading(false);
        }
    }, [requestState]);
    async function getAccountsPayable(params) {
        const requestId = ++requestIdRef.current;
        timedOutRef.current = false;
        setError(undefined);
        setAccountsPayable(undefined);
        setLoading(true);
        startTracking();
        try {
            const response = await trigger(params, false);
            if (requestId !== requestIdRef.current || timedOutRef.current) {
                return;
            }
            if (!response) {
                setError(t('select-contact-get-favorites-error-message'));
                stopTracking(RequestTimeoutState.Error);
                return;
            }
            const { data, error } = response;
            if (error) {
                setError(t('select-contact-get-favorites-error-message'));
                stopTracking(RequestTimeoutState.Error);
                return;
            }
            if (data?.result) {
                const newAccountsPayable = {
                    ...data.result,
                    data: [...(accountsPayable?.data ?? []), ...data.result.data],
                };
                setAccountsPayable(newAccountsPayable);
                stopTracking(RequestTimeoutState.Success);
                return newAccountsPayable;
            }
            stopTracking(RequestTimeoutState.Success);
        }
        catch {
            if (requestId !== requestIdRef.current || timedOutRef.current) {
                return;
            }
            setError(t('select-contact-get-favorites-error-message'));
            stopTracking(RequestTimeoutState.Error);
            return;
        }
        finally {
            if (requestId === requestIdRef.current && !timedOutRef.current) {
                setLoading(false);
            }
        }
    }
    return {
        error,
        accountsPayable,
        loading,
        requestState,
        getAccountsPayable,
        setAccountsPayable,
        setLoading,
        setError,
        resetRequestState: reset,
    };
}
